import React from 'react'

export const missouriSetupVars = {
  siteId: 'missouri',
  pathPrefix: '/mo',
  menuHeader: "Discover Missouri's Solution for:",
  appUrl: 'https://mo.headed2.com',
  logoImg: '/images/assets/missouri/horizontal/dark.svg',
  headerTitle: `The Missouri CareerExplorer is a system designed for Missouri`
}
